import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { take, tap } from 'rxjs';

import { LoginFlowInitiated } from '@troyai/auth/data-access';
import { GreetingCardComponent } from '@troyai/auth/feature';
import { Environment } from '@troyai/envs';
import { ButtonComponent } from '@troyai/ui-kit';

@Component({
  imports: [GreetingCardComponent, ButtonComponent],
  templateUrl: './logout-shell.component.html',
})
export class LogoutShellComponent {
  private store = inject(Store);
  private env = inject(Environment);
  private route = inject(ActivatedRoute);

  constructor() {
    this.route.queryParamMap
      .pipe(
        take(1),
        tap((params) => {
          const shouldRetryLogin = params.get('forceRetryLogin');
          if (shouldRetryLogin) {
            return this.loginWithRedirect();
          }
          this.isLoading = false;
        })
      )
      .subscribe();
  }

  isLoading = true;

  loginWithRedirect(): void {
    this.store.dispatch(
      new LoginFlowInitiated({
        redirectUrl: '',
      })
    );
  }
}
